<template>
  <v-row class="pb-1 mt-3 mb-2 mx-0" no-gutters>
    <v-col cols="9">
      <v-btn-toggle
        :model-value="weekOptions.includes(modelValue) ? modelValue : 0"
        mandatory
        border="thin opacity-75"
        divided
        @update:model-value="updateValue"
      >
        <v-btn
          v-for="(week, index) in weekOptions"
          :key="`options-${index}`"
          :value="week"
          class="dates-selection__group-button"
        >
          {{ week || 'Custom' }}
        </v-btn>
      </v-btn-toggle>
    </v-col>
    <v-col cols="3">
      <v-text-field
        :model-value="modelValue"
        single-line
        density="compact"
        hide-details
        class="pa-0 ma-0 ml-4 dates-selection__input--custom"
        :style="{ height: '100%' }"
        :placeholder="placeholder"
        type="number"
        @update:model-value="val => updateValue(Number(val), true)"
      />
    </v-col>
  </v-row>
</template>

<script setup>
defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  weekOptions: {
    type: Array,
    required: true,
  },
  placeholder: {
    type: String,
    default: 'Custom',
  },
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (value, fromInput) => {
  // The value of "custom" is 0. This is important for how vuetify handles button state.
  // fromInputs distinguishes between inputs from button clicks and manual user entry.
  // This is to ensure the tooltip fires on their input but not when they click 'custom'
  if (value === 0 && !fromInput) value += 1;
  emit('update:modelValue', value);
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.dates-selection {
  background-color: $assortment-workpackage-frame-bg-blue;

  &__group-button {
    border-color: $assortment-primary-colour !important;
    height: 32px !important;
    flex: 1;

    :deep(:not(.v-btn--active)) {
      background-color: transparent !important;
    }
  }
}

:deep(.v-btn-group) {
  width: 100%;
}
</style>
